export default ({
    name : 'Category'
    , props : {
        'textColorStyle' : Object // common_header computed value.
    }
    , data () {
        return {
            categoryList : []
        }
    }
    , created () {
        this.code = 'hamburger_menu';
        this.basic = this.getDetailDataByCode(this.code);
        if (this.basic.use == 'Y' && this.basic.data.category_use.value == 'Y') {
            this.getCategoryList();
        }
        return {}
    }
    , computed : {
        isUseCategory : function () {
            if (this.basic.use == 'N') { 
                return false
            }
            if (this.basic.data.category_use.value == 'N') { 
                return false
            }
            return true;
        }
        , isShowCategory : function () {
            if (this.categoryList.length > 0) return true
            return false
        }
    }
	, mounted () {
        this.publisher();
    }
    , methods : {
        publisher () {
            this.setContainerHeight()
        }
        , setContainerHeight () {
            let header    = document.querySelector('#header')
            let container = document.querySelector('#container')
            if (header === null && container === null) {
                return
            }
            container.style.marginTop = header.offsetHeight+'px'
        }
        , getCategoryList () {
            let params = new FormData()
            this.$http.post(`${this.baseURI}${this.displayDataUrl['topCategory']}`, params, { headers : this.axiosCommonHeader }
            ).then(response => {
                if (response.data.length == 0) {
                    return
                }
                this.setCategoryList(response.data)
            }).catch(error => {
            })
        }
        , setCategoryList (data) {
            if (data.list.length == 0) {
                this.execCategoryListEmptyState()
                return
            }
            this.categoryList = data.list;

            this.$nextTick(function () {
                this.setContainerHeight()
            });
        }
        , execCategoryListEmptyState () {
            if (this.categoryList.length > 0) { // ex> 3 > 0 으로 저장.
                this.categoryList = [] 
            }
        }
        , checkCategoryDisplayChange () {
            let category        = this.basic.data.category_display.value
            let categoryIds     = []
            for (var i in category) {
                if ("ppc_id" in category[i] && category[i].ppc_menu_display == 'Y') {
                    categoryIds.push(category[i].ppc_id);
                }
            }
            if (categoryIds.length < 1) { 
                this.execCategoryListEmptyState()
                return false 
            }
            if (this.categoryList.length < 1 && categoryIds.length > 0) { return true }
            if (this.categoryList.length > categoryIds.length         ) { return true }

            let isMore = false
            let nowCategoryList = this.categoryList
            let categoryListIds = []
            for (var j in nowCategoryList) {
                if ("ppc_id" in nowCategoryList[j] && nowCategoryList[j].ppc_menu_display == 'Y') {
                    categoryListIds.push(nowCategoryList[j].ppc_id)
                }
            }
            for (var k in categoryIds) {
                if (categoryListIds.includes(categoryIds[k]) === false) {
                    isMore = true
                }
            }
            return isMore
        }
        , setCategoryListAdmin () {
            let category = this.basic.data.category_display.value
            let list = []
            for (let k in category) {
                let data = category[k]
                if ("ppc_id" in data && data.ppc_menu_display == 'Y') {
                    list.push(data)
                }
            }
            this.categoryList = list

            this.$nextTick(function () {
                this.setContainerHeight()
            });
        }
        , categoryMoveUrl (url) {
            if (this.getAdminEditMode()) { 
                return "javascript:void(0);"
            }
            return url
        }
        , isSubCategory : function (sub) {
            if (sub.length > 0) return true
            return false
        }
    }
    , updated () {
        if (this.getAdminEditMode() && this.isSetBasicData('category_display')) {
            if (this.checkCategoryDisplayChange()) {
                this.setCategoryListAdmin()
            }
        }
    }
})
